import PropTypes from 'prop-types';

import { Typography } from '@mui/material';

import Actions from '../Modal/ActionsComponent';

const InactivityModalComponent = ({
  state: { secondsRemaining },
  props: { onConfirm, onCancel },
}) => {
  const actions = [
    { label: 'Stay logged in', onClick: onConfirm, color: 'primary' },
    {
      label: 'Log out',
      onClick: onCancel,
      color: 'secondary',
    },
  ];
  return (
    <>
      <Typography variant="body1">
        <span>For your security, you will be logged out of&nbsp;</span>
        <span>
          Carson in&nbsp;
          <span>{secondsRemaining}</span>
          &nbsp;seconds. Would you like to&nbsp;
        </span>
        <span>stay logged in?</span>
      </Typography>
      <Actions actions={actions} />
    </>
  );
};

InactivityModalComponent.propTypes = {
  state: PropTypes.shape({
    secondsRemaining: PropTypes.number.isRequired,
  }).isRequired,
  props: PropTypes.shape({
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
  }).isRequired,
};

export default InactivityModalComponent;
